export default __webpack_public_path__ + "static/media/elon.4a73afe5.jpg";